module.exports = __webpack_public_path__ + "img/logo.a5a31333.webp";